import { FC, useEffect } from "react";
import { useField } from "formik";
import { IFormProps } from ".";
import { BoolControlViewModel } from "../Models";
import { CheckBox } from "src/UI";
import st from "../DynamicForm.module.scss";

interface ICheckBoxTextProps extends IFormProps {
	model: BoolControlViewModel;
};

const CheckBoxText: FC<ICheckBoxTextProps> = ( props ) => {

	const { model, readOnly = false, setFieldValue } = props;
	const [ inputProps,, helperProps ] = useField( model.FullPath );

	useEffect( () => {
		helperProps.setValue( model.Value, true );
	// eslint-disable-next-line
	}, [ model.Value ] );

	const onChangeValue = ( value: boolean ) => setFieldValue( model.FullPath, value );

	return (
		<CheckBox
			hidden={!model.ControlVisibility}
			className={st.controlCB} 
			name={model.FullPath} 
			value={!!inputProps.value} 
			disabled={ !model.ControlEnabling || readOnly }
			onChangeValue={onChangeValue}
		>
			{ model.Caption }
		</CheckBox>
	);
};

export default CheckBoxText;
